import React from 'react';
import { ListItemIcon, ListItemText, ListItemButton, styled } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

interface StyledListItemButtonProps {
  nested: number;
}

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 30,
  color: 'inherit',
  '& > svg': {
    fontSize: 20,
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& > span': {
    color: 'inherit',
    fontSize: 13,
    fontWeight: 700,
  },
}));

const StyledListItemButton = styled(ListItemButton)<StyledListItemButtonProps>(({ theme, nested }) => ({
  padding: theme.spacing(0.875, 1.25),
  paddingLeft: nested ? theme.spacing(nested) : theme.spacing(1.25),
  minHeight: 42,
  gap: theme.spacing(1),
  marginBottom: 2,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.secondary,
  transition: 'background-color 0.2s ease, color 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.primary.main,
    '& svg': {
      color: theme.palette.primary.main,
    },
  },
}));

interface SidebarItemProps {
  text: string;
  icon: React.ReactElement;
  opened: boolean;
  onClick: () => void;
  nested?: number;
}

const SidebarItemExpendable: React.FC<SidebarItemProps> = ({ icon, text, opened, onClick, nested = 0 }) => {
  return (
    <StyledListItemButton nested={nested} onClick={onClick}>
      <StyledListItemIcon color="inherit">{icon}</StyledListItemIcon>
      <StyledListItemText primary={text} />
      {opened ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
    </StyledListItemButton>
  );
};

export default SidebarItemExpendable;
